import { faTable } from "@fortawesome/free-solid-svg-icons";

import PartnerOrganizationList from "./pages/PartnerOrganizationList";
import PartnerOrganizationDetails from "./pages/PartnerOrganizationDetails";

export const partnersRoutes = [
  {
    path: "/partners",
    breadcrumb: "Partners",
    component: PartnerOrganizationList,
  },
  {
    path: "/partners/:id",
    breadcrumb: "Partner Details",
    component: PartnerOrganizationDetails,
  },
];

export const partnersSidebarRoutes = [
  {
    path: "/partners",
    label: "Partners",
    icon: faTable,
  },
];
